import { Routes } from '@angular/router';
import { permissionGuard } from '@core/auth/permission.guard';
import { APP_PERMISSIONS } from '@core/constants/permission.constants';
import { APP_ROUTES } from '@core/constants/routes.constants';

export const regionalClimateReferencesRoutes: Routes = [
  {
    title: 'pagesTitles.regionalClimateReferences',
    path: APP_ROUTES.REGIONAL_CLIMATE_REFERENCES,
    canActivate: [permissionGuard(APP_PERMISSIONS.RegionalClimateReferenceRead)],
    loadComponent: () =>
      import('./pages/regional-climate-references-list').then(
        (m) => m.RegionalClimateReferencesList
      ),
  },
];
